import {Injectable} from '@angular/core';
import {filter, takeUntil} from 'rxjs/operators';
import {USER_TOPIC} from '../../../../main';
import {OpenServerErrorEvent} from '../../models';
import {ComponentCleaner} from '../../component-cleaner';
import {R2CloudStompService} from '../../ws/r2-cloud-stomp.service';
import {BusinessErrorDialogService} from '../../error/business-error-dialog.service';
import {openServerErrorMessage} from './open-server-error-rules';

/**
 * R2CLOUD-1259 — leva à tela a recusa de "Abrir com Usuário do AD", que até aqui morria na API.
 *
 * O `open-modal-ad-admin` manda `SEND /stomp/open-ad-admin` e fecha o dialog; o resultado, quando é
 * "não abriu", volta por outro caminho — `/user/topic/open-server-error`, no canal do próprio
 * usuário. É por isso que quem escuta é um serviço `root` e não o componente do botão: o dialog já
 * foi fechado quando a resposta chega, e o mesmo pedido também parte do painel de administração de
 * projetos, não só da tela Desktop.
 *
 * Mesmo formato do `DownloadFileService`: serviço `providedIn: 'root'` que assina um tópico do
 * usuário logado. A diferença é `start()` em vez de assinar no construtor — quem chama é o
 * `AppComponent`, no bloco `if (me && isLoggedIn)`, que reemite a cada mudança de sessão.
 *
 * O texto não é decidido aqui: vem de `open-server-error-rules.ts`, coberto por `npm test`.
 */
@Injectable({
    providedIn: 'root'
})
export class OpenServerErrorService extends ComponentCleaner {

    private started = false;

    constructor(private stomp: R2CloudStompService,
                private businessErrorDialogService: BusinessErrorDialogService) {
        super();
    }

    /**
     * Assina o tópico da recusa. Idempotente de propósito — mesma guarda de
     * `DesktopServerService.initDesktopSubscriptions()`: o `isLoggedIn()` do `AppComponent` emite
     * mais de uma vez por sessão, e sem a guarda cada emissão empilharia uma assinatura a mais.
     */
    start(): void {
        if (this.started) {
            return;
        }
        this.started = true;
        this.addSubscription(this.stomp.stompTopic<OpenServerErrorEvent>(`${USER_TOPIC}/open-server-error`).pipe(
            takeUntil(this.onDestroy$),
            filter((event): event is OpenServerErrorEvent => !!event)
        ).subscribe((event) => {
            this.businessErrorDialogService.open(openServerErrorMessage(event.reason, event.hostname));
        }));
    }
}
